export const Encrption = (id) => {
    const CryptoJS = require('crypto-js');
    const key = CryptoJS.enc.Utf8.parse("8674834030082752");
    const iv = CryptoJS.enc.Utf8.parse("9845009819491522");

    var srcs = CryptoJS.enc.Utf8.parse(id);
    let encryptedId = CryptoJS.AES.encrypt(srcs, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString()
    return encodeURIComponent(encryptedId)
}


